import PropTypes from "prop-types";
import React from "react";
import { View, TouchableOpacity, ScrollView } from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
// import { styleSheet, colors, sizes, WIDTH } from "app/utils/styleSheet";
import { Feather } from "@expo/vector-icons";
import colorHelpers from "app/utils/colorHelpers";
import { StyleContext } from "app/contexts/Style";

export default class SideModal extends React.Component {
  static contextType = StyleContext;
  render() {
    let { title, onHide, sections, width } = this.props;
    return (
      <View
        style={[
          this.styles().wrapper,
          { width: ENV.WEB ? width : this.context.WIDTH },
        ]}
      >
        <ScrollView>
          <TouchableOpacity onPress={this.props.onHide}>
            <View style={this.styles().topHeader}>
              <Text bold style={{ fontSize: this.context.sizes.large }}>
                {title}
              </Text>
              <Text>
                <Feather
                  style={{ fontSize: this.context.sizes.large }}
                  name="x"
                />
              </Text>
            </View>
          </TouchableOpacity>

          {sections.map((section, i) => {
            return (
              <View key={i}>
                <Text bold style={this.styles().header}>
                  {section.title}
                </Text>
                {section.content.map((c, j) => {
                  return (
                    <View key={j} style={this.styles().row}>
                      {c}
                    </View>
                  );
                })}
                <View style={this.styles().gap} />
              </View>
            );
          })}
        </ScrollView>
      </View>
    );
  }

  setLightScheme = (scheme) => {
    this.setState({ lightScheme: scheme });
  };
  setDarkScheme = (scheme) => {
    this.setState({ darkScheme: scheme });
  };
  setSchemeMode = (mode) => {
    this.setState({ selectedSchemeMode: mode });
  };

  styles = () => ({
    wrapper: {
      borderRadius: this.context.sizes.smallBorderRadius,
      position: "fixed",
      position: "absolute",
      right: 0,
      top: 0,
      bottom: 0,
      backgroundColor: colorHelpers.hexToRgbaString(
        this.context.colors.empty,
        0.91
      ),
      backgroundColor: this.context.colors.fill,
      padding: this.context.sizes.large,
      paddingTop: ENV.WEB ? 0 : 50,
      borderLeftWidth: 1,
      borderColor: this.context.colors.trim,
    },
    topHeader: {
      height: 65,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      // borderWidth: 2,
      borderColor: "red",
      paddingHorizontal: this.context.sizes.small,
    },
    header: {
      // borderBottomWidth: 1,
      borderColor: this.context.colors.trim,
      fontWeight: "bold",
      marginBottom: this.context.sizes.base,
      // borderRadius: this.context.sizes.smallBorderRadius,
      backgroundColor: colorHelpers.hexToRgbaString(
        this.context.colors.fill,
        0.8
      ),
      backgroundColor: colorHelpers.hexToRgbaString(
        this.context.colors.trim,
        0.6
      ),
      padding: this.context.sizes.small,
      paddingHorizontal: this.context.sizes.base,
      // textAlign: "right",
    },
    row: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: this.context.sizes.base,
      // paddingHorizontal: this.context.sizes.small,
      // borderBottomWidth: 1,
      // borderColor: this.context.colors.fill,
      paddingBottom: this.context.sizes.small,
    },
    gap: {
      height: this.context.sizes.large,
    },
  });
}
